const API_URL = process.env.REACT_APP_BASE_URL  || 'https://endeavour.insightbox.co.uk/api'
// const API_URL = process.env.REACT_APP_BASE_URL  || 'https://2d90-122-170-59-226.in.ngrok.io'
const MAIN_URL = process.env.REACT_APP_BASE_URL  || 'https://endeavour.insightbox.co.uk'
// const API_URL = process.env.REACT_APP_BASE_URL  || 'https://1659-2405-201-200d-2a24-3532-358-f8c-50b.in.ngrok.io'
// const API_URL = process.env.REACT_APP_BASE_URL  || 'https://ch-fullcae.herokuapp.com'
export { API_URL,MAIN_URL };